function ProductSuppliesPage() {
	return <>ProductSuppliesPage</>;
}

export default ProductSuppliesPage;
